/**
 * @file Navbar/index.js
 * @author zhuwanying02
 */
import Navbar from './Navbar.js';
import NavbarBrand from './NavbarBrand.js';
import NavbarMain from './NavbarContent.js';
import NavbarAddition from './NavbarAddition.js';
import NavbarMulti from './NavbarMulti';

Navbar.Brand = NavbarBrand;
Navbar.Main = NavbarMain;
Navbar.Addition = NavbarAddition;
Navbar.Multi = NavbarMulti;
export { NavbarBrand, NavbarMain, NavbarAddition, NavbarMulti };
export default Navbar;